"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("react-bootstrap/Button"));
var action_type_enum_1 = __importDefault(require("../../shared/enums/action-type.enum"));
var priority_enum_1 = __importDefault(require("../../shared/enums/priority.enum"));
var size_enum_1 = __importDefault(require("../../shared/enums/size.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var enhanced_icon_1 = __importDefault(require("../enhanced-icon"));
var icon_1 = __importDefault(require("../icon"));
function Action(props) {
    var _a;
    var styleClass = (props.style && props.style === "rounded" ? "rounded-pill" : props.style) || "";
    var content = (props.icon && props.text && (react_1.default.createElement(enhanced_icon_1.default, __assign({}, props.icon, { title: props.text })))) ||
        (props.icon && react_1.default.createElement(icon_1.default, __assign({}, props.icon, { title: props.text }))) ||
        props.text ||
        "";
    var clickHandler = function (event) {
        event.stopPropagation();
        if (props.callback)
            props.callback();
    };
    return (react_1.default.createElement(Button_1.default, { "aria-label": props.text || props.ariaLabel || "button", variant: props.priority || priority_enum_1.default.PRIMARY, size: props.size && props.size !== size_enum_1.default.MEDIUM ? props.size : size_enum_1.default.LARGE, disabled: props.enabled !== undefined ? !props.enabled : false, onClick: clickHandler, type: props.type || action_type_enum_1.default.BUTTON, tabIndex: (_a = props.tabIndex) !== null && _a !== void 0 ? _a : undefined, className: (0, classMap_1.default)("mpng-ux-action shape", styleClass, props.className) }, content));
}
exports.default = Action;
